/* eslint-disable react/prop-types */
import React from "react";
import { Helmet } from "react-helmet-async";
import TransportDocTool from "@/components/tools/TransportDocTool";

/**
 * /embed/transport-doc — chrome-less version of the transport document tool
 * for third-party websites to embed via <iframe>.
 *
 * No header, footer, announcement bar, cookie banner — just the tool plus
 * a tiny attribution badge that links back to EquiSight (the backlink).
 *
 * Hosted on a route the prerender script skips so Helmet sets noindex.
 */
export default function TransportDocEmbed() {
  return (
    <main
      data-testid="embed-transport-doc"
      className="min-h-screen bg-background px-4 py-6"
    >
      <Helmet>
        <title>EquiSight — Vervoersdocument generator (embed)</title>
        <meta name="robots" content="noindex,follow" />
        {/* Allow framing across origins via CSP meta. Note: real protection
            must also be set in the ingress (frame-ancestors *). */}
        <meta
          httpEquiv="Content-Security-Policy"
          content="frame-ancestors *"
        />
      </Helmet>

      <div className="mx-auto max-w-2xl">
        <TransportDocTool variant="embed" />

        <p className="mt-6 text-center text-[11px] text-[hsl(var(--ink-soft))]">
          Powered by{" "}
          <a
            href="https://equisight.nl/tools/vervoersdocument-paard?utm_source=embed&utm_medium=widget&utm_campaign=transport-doc"
            target="_blank"
            rel="noopener"
            className="font-semibold text-[hsl(var(--forest))] underline"
            data-testid="embed-attribution-link"
          >
            EquiSight — paardenmanagement app
          </a>
        </p>
      </div>
    </main>
  );
}
